export default __webpack_public_path__ + "static/media/transferencia_gana.e650999a.png";